/*
 * Copyright 2022 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import { CssBaseline, ThemeProvider } from "@material-ui/core";
import {
    DialogProviderV1,
    historyV1,
    lightV1,
    NotificationProviderV1,
} from "@startree-ui/platform-ui";
import "@startree-ui/platform-ui/assets/styles/fonts.scss";
import "@startree-ui/platform-ui/assets/styles/layout.scss";
import { enableAllPlugins } from "immer";
import React, { StrictMode } from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import { App } from "./app";
import { AnalyticsProviderWrapper } from "./components/analytics-provider-wrapper/analytics-provider-wrapper.component";
import { AuthProviderAuth0 } from "./components/auth-provider-auth0/auth-provider-auth0.component";
import { CustomerSupportProviderWrapper } from "./components/customer-support-provider-wrapper/customer-support-provider-wrapper.component";
import { SubmitUserToHubspotProvider } from "./components/submit-user-to-hubspot-provider/submit-user-to-hubspot-provider.component";
import { UserProvider } from "./components/user-provider/user-provider.component";
import { initLocale } from "./utils/locale/locale.util";

// Initialize locale
initLocale();

// Initialize Immer to handle maps and sets
enableAllPlugins();

ReactDOM.render(
    <StrictMode>
        {/* Material UI theme */}
        <ThemeProvider theme={lightV1}>
            <CssBaseline />

            {/* App rendered by a router to allow navigation using app bar */}
            <Router history={historyV1}>
                <DialogProviderV1>
                    <NotificationProviderV1>
                        <AuthProviderAuth0>
                            <UserProvider>
                                <AnalyticsProviderWrapper>
                                    <SubmitUserToHubspotProvider>
                                        <CustomerSupportProviderWrapper>
                                            <App />
                                        </CustomerSupportProviderWrapper>
                                    </SubmitUserToHubspotProvider>
                                </AnalyticsProviderWrapper>
                            </UserProvider>
                        </AuthProviderAuth0>
                    </NotificationProviderV1>
                </DialogProviderV1>
            </Router>
        </ThemeProvider>
    </StrictMode>,
    document.getElementById("root") as HTMLElement
);
